import { IStockVideoFileDto, IStockVideoDto } from 'src/types'

export const getStockVideoLinks = (videoFiles: IStockVideoFileDto[]) => {
  let highestQuality = videoFiles[0]
  let mediumQuality = null
  let lowestQuality = null

  for (const videoFile of videoFiles) {
    if (videoFile.quality === 'hd') {
      if (!highestQuality || videoFile.width > highestQuality.width) {
        highestQuality = videoFile
      }
    } else if (videoFile.quality === 'sd') {
      if (!mediumQuality || videoFile.width > mediumQuality.width) {
        mediumQuality = videoFile
      }
      if (!lowestQuality || videoFile.width < lowestQuality.width) {
        lowestQuality = videoFile
      }
    }
  }

  return {
    link: highestQuality.link,
    link_medium: mediumQuality ? mediumQuality.link : null,
    link_small: lowestQuality ? lowestQuality.link : null,
  }
}

export const getLowestQualityVideoLink = (item: IStockVideoDto): string => {
  if (item.video_files.length === 0) {
    return ''
  }
  let lowestQualityVideo = item.video_files[0]
  for (const video of item.video_files) {
    if (video.height < lowestQualityVideo.height) {
      lowestQualityVideo = video
    }
  }

  return lowestQualityVideo.link
}
